var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInvoices(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 505 219",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_16043)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.0073 218.839H-116.267V125.691H27.0073V218.839Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0074 218.839H-116.267V125.691H27.0074V218.839Z",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.471 65.627H447.811L447.996 65.1642L450.479 58.9589L450.748 58.2868L453.466 51.4919L454.416 49.1162L456.965 42.7442L458.491 38.9299L461.512 31.3786L462.247 29.5386L465.35 21.7837L465.353 21.774L466.596 18.6666L467.538 16.3121L468.065 14.9947H591.217L591.446 15.5671L592.121 17.255L595.02 24.4992L595.383 25.4115L596.801 28.9548L597.842 31.5533L599.607 35.9705L599.867 36.6195V36.6215L602.912 44.2304L603.56 45.8514L605.107 49.7156V49.7173L606.382 52.9035L607.405 55.4597L607.434 55.5308V55.5326L611.26 65.0987L611.471 65.627Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.471 65.627H447.811L447.996 65.1642L450.479 58.9589L450.748 58.2868L453.466 51.4919L454.416 49.1162L456.965 42.7442L458.491 38.9299L461.512 31.3786L462.247 29.5386L465.35 21.7837L465.353 21.774L466.596 18.6666L467.538 16.3121L468.065 14.9947H591.217L591.446 15.5671L592.121 17.255L595.02 24.4992L595.383 25.4115L596.801 28.9548L597.842 31.5533L599.607 35.9705L599.867 36.6195V36.6215L602.912 44.2304L603.56 45.8514L605.107 49.7156V49.7173L606.382 52.9035L607.405 55.4597L607.434 55.5308V55.5326L611.26 65.0987L611.471 65.627Z",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.411 218.737H603.873V65.8208H455.411V218.737Z",
    fill: "white",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.149994,
    d: "M490.612 93.2872H505.813V80.5441H490.612V93.2872Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.149994,
    d: "M466.702 93.2872H481.902V80.5441H466.702V93.2872Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.149994,
    d: "M490.612 111.382H505.813V98.6389H490.612V111.382Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.149994,
    d: "M466.702 111.382H481.902V98.6389H466.702V111.382Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.149994,
    d: "M490.612 129.477H505.813V116.734H490.612V129.477Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.149994,
    d: "M466.702 129.477H481.902V116.734H466.702V129.477Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.149994,
    d: "M490.612 147.572H505.813V134.829H490.612V147.572Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.149994,
    d: "M466.702 147.572H481.902V134.829H466.702V147.572Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.149994,
    d: "M490.612 165.667H505.813V152.924H490.612V165.667Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.149994,
    d: "M466.702 165.667H481.902V152.924H466.702V165.667Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.262 60.6353C492.262 57.7716 495.304 55.45 499.058 55.45C502.812 55.45 505.854 57.7716 505.854 60.6353C505.854 63.499 502.812 65.8207 499.058 65.8207C495.304 65.8207 492.262 63.499 492.262 60.6353Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.262 60.6353C492.262 57.7716 495.304 55.45 499.058 55.45C502.812 55.45 505.854 57.7716 505.854 60.6353C505.854 63.499 502.812 65.8207 499.058 65.8207C495.304 65.8207 492.262 63.499 492.262 60.6353Z",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.669 60.6353C478.669 57.7716 481.712 55.45 485.466 55.45C489.219 55.45 492.262 57.7716 492.262 60.6353C492.262 63.499 489.219 65.8207 485.466 65.8207C481.712 65.8207 478.669 63.499 478.669 60.6353Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.669 60.6353C478.669 57.7716 481.712 55.45 485.466 55.45C489.219 55.45 492.262 57.7716 492.262 60.6353C492.262 63.499 489.219 65.8207 485.466 65.8207C481.712 65.8207 478.669 63.499 478.669 60.6353Z",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.076 60.6353C465.076 57.7716 468.119 55.45 471.873 55.45C475.626 55.45 478.669 57.7716 478.669 60.6353C478.669 63.499 475.626 65.8207 471.873 65.8207C468.119 65.8207 465.076 63.499 465.076 60.6353Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.076 60.6353C465.076 57.7716 468.119 55.45 471.873 55.45C475.626 55.45 478.669 57.7716 478.669 60.6353C478.669 63.499 475.626 65.8207 471.873 65.8207C468.119 65.8207 465.076 63.499 465.076 60.6353Z",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.484 60.6353C451.484 57.7716 454.527 55.45 458.28 55.45C462.034 55.45 465.076 57.7716 465.076 60.6353C465.076 63.499 462.034 65.8207 458.28 65.8207C454.527 65.8207 451.484 63.499 451.484 60.6353Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.484 60.6353C451.484 57.7716 454.527 55.45 458.28 55.45C462.034 55.45 465.076 57.7716 465.076 60.6353C465.076 63.499 462.034 65.8207 458.28 65.8207C454.527 65.8207 451.484 63.499 451.484 60.6353Z",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.059 53.8496C499.059 50.9858 502.101 48.6642 505.855 48.6642C509.608 48.6642 512.651 50.9858 512.651 53.8496C512.651 56.7133 509.608 59.0349 505.855 59.0349C502.101 59.0349 499.059 56.7133 499.059 53.8496Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.059 53.8496C499.059 50.9858 502.101 48.6642 505.855 48.6642C509.608 48.6642 512.651 50.9858 512.651 53.8496C512.651 56.7133 509.608 59.0349 505.855 59.0349C502.101 59.0349 499.059 56.7133 499.059 53.8496Z",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.465 53.8496C485.465 50.9858 488.508 48.6642 492.262 48.6642C496.015 48.6642 499.058 50.9858 499.058 53.8496C499.058 56.7133 496.015 59.0349 492.262 59.0349C488.508 59.0349 485.465 56.7133 485.465 53.8496Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.465 53.8496C485.465 50.9858 488.508 48.6642 492.262 48.6642C496.015 48.6642 499.058 50.9858 499.058 53.8496C499.058 56.7133 496.015 59.0349 492.262 59.0349C488.508 59.0349 485.465 56.7133 485.465 53.8496Z",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.873 53.8496C471.873 50.9858 474.916 48.6642 478.669 48.6642C482.423 48.6642 485.465 50.9858 485.465 53.8496C485.465 56.7133 482.423 59.0349 478.669 59.0349C474.916 59.0349 471.873 56.7133 471.873 53.8496Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.873 53.8496C471.873 50.9858 474.916 48.6642 478.669 48.6642C482.423 48.6642 485.465 50.9858 485.465 53.8496C485.465 56.7133 482.423 59.0349 478.669 59.0349C474.916 59.0349 471.873 56.7133 471.873 53.8496Z",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.44 53.8496C458.44 50.9858 461.483 48.6642 465.237 48.6642C468.991 48.6642 472.033 50.9858 472.033 53.8496C472.033 56.7133 468.991 59.0349 465.237 59.0349C461.483 59.0349 458.44 56.7133 458.44 53.8496Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.44 53.8496C458.44 50.9858 461.483 48.6642 465.237 48.6642C468.991 48.6642 472.033 50.9858 472.033 53.8496C472.033 56.7133 468.991 59.0349 465.237 59.0349C461.483 59.0349 458.44 56.7133 458.44 53.8496Z",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.262 47.832C492.262 44.9683 495.304 42.6466 499.058 42.6466C502.812 42.6466 505.854 44.9683 505.854 47.832C505.854 50.6957 502.812 53.0173 499.058 53.0173C495.304 53.0173 492.262 50.6957 492.262 47.832Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.262 47.832C492.262 44.9683 495.304 42.6466 499.058 42.6466C502.812 42.6466 505.854 44.9683 505.854 47.832C505.854 50.6957 502.812 53.0173 499.058 53.0173C495.304 53.0173 492.262 50.6957 492.262 47.832Z",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.669 47.832C478.669 44.9683 481.712 42.6466 485.466 42.6466C489.219 42.6466 492.262 44.9683 492.262 47.832C492.262 50.6957 489.219 53.0173 485.466 53.0173C481.712 53.0173 478.669 50.6957 478.669 47.832Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.669 47.832C478.669 44.9683 481.712 42.6466 485.466 42.6466C489.219 42.6466 492.262 44.9683 492.262 47.832C492.262 50.6957 489.219 53.0173 485.466 53.0173C481.712 53.0173 478.669 50.6957 478.669 47.832Z",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.076 47.832C465.076 44.9683 468.119 42.6466 471.873 42.6466C475.626 42.6466 478.669 44.9683 478.669 47.832C478.669 50.6957 475.626 53.0173 471.873 53.0173C468.119 53.0173 465.076 50.6957 465.076 47.832Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.076 47.832C465.076 44.9683 468.119 42.6466 471.873 42.6466C475.626 42.6466 478.669 44.9683 478.669 47.832C478.669 50.6957 475.626 53.0173 471.873 53.0173C468.119 53.0173 465.076 50.6957 465.076 47.832Z",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.076 47.8314C465.076 48.1177 465.046 48.3978 464.988 48.6706C464.474 51.0751 461.795 52.9245 458.529 53.0111C458.469 53.0147 458.412 53.0167 458.352 53.0147C458.329 53.0167 458.304 53.0167 458.281 53.0167C456.4 53.0167 454.697 52.4329 453.466 51.4918L454.416 49.1161L456.965 42.7441C457.39 42.6786 457.831 42.646 458.281 42.646C458.392 42.646 458.504 42.6481 458.614 42.6537H458.615C461.487 42.7573 463.89 44.2247 464.744 46.2239C464.959 46.729 465.076 47.2705 465.076 47.8314Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.076 47.8314C465.076 48.1177 465.046 48.3978 464.988 48.6706C464.474 51.0751 461.795 52.9245 458.529 53.0111C458.469 53.0147 458.412 53.0167 458.352 53.0147C458.329 53.0167 458.304 53.0167 458.281 53.0167C456.4 53.0167 454.697 52.4329 453.466 51.4918L454.416 49.1161L456.965 42.7441C457.39 42.6786 457.831 42.646 458.281 42.646C458.392 42.646 458.504 42.6481 458.614 42.6537H458.615C461.487 42.7573 463.89 44.2247 464.744 46.2239C464.959 46.729 465.076 47.2705 465.076 47.8314Z",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.059 41.0462C499.059 38.1825 502.101 35.8609 505.855 35.8609C509.608 35.8609 512.651 38.1825 512.651 41.0462C512.651 43.9099 509.608 46.2316 505.855 46.2316C502.101 46.2316 499.059 43.9099 499.059 41.0462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.059 41.0462C499.059 38.1825 502.101 35.8609 505.855 35.8609C509.608 35.8609 512.651 38.1825 512.651 41.0462C512.651 43.9099 509.608 46.2316 505.855 46.2316C502.101 46.2316 499.059 43.9099 499.059 41.0462Z",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.465 41.0462C485.465 38.1825 488.508 35.8609 492.262 35.8609C496.015 35.8609 499.058 38.1825 499.058 41.0462C499.058 43.9099 496.015 46.2316 492.262 46.2316C488.508 46.2316 485.465 43.9099 485.465 41.0462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.465 41.0462C485.465 38.1825 488.508 35.8609 492.262 35.8609C496.015 35.8609 499.058 38.1825 499.058 41.0462C499.058 43.9099 496.015 46.2316 492.262 46.2316C488.508 46.2316 485.465 43.9099 485.465 41.0462Z",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.873 41.0462C471.873 38.1825 474.916 35.8609 478.669 35.8609C482.423 35.8609 485.465 38.1825 485.465 41.0462C485.465 43.9099 482.423 46.2316 478.669 46.2316C474.916 46.2316 471.873 43.9099 471.873 41.0462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.873 41.0462C471.873 38.1825 474.916 35.8609 478.669 35.8609C482.423 35.8609 485.465 38.1825 485.465 41.0462C485.465 43.9099 482.423 46.2316 478.669 46.2316C474.916 46.2316 471.873 43.9099 471.873 41.0462Z",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.28 41.0462C458.28 38.1825 461.323 35.8609 465.076 35.8609C468.83 35.8609 471.873 38.1825 471.873 41.0462C471.873 43.9099 468.83 46.2316 465.076 46.2316C461.323 46.2316 458.28 43.9099 458.28 41.0462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.28 41.0462C458.28 38.1825 461.323 35.8609 465.076 35.8609C468.83 35.8609 471.873 38.1825 471.873 41.0462C471.873 43.9099 468.83 46.2316 465.076 46.2316C461.323 46.2316 458.28 43.9099 458.28 41.0462Z",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.262 33.7484C492.262 30.8846 495.304 28.563 499.058 28.563C502.812 28.563 505.854 30.8846 505.854 33.7484C505.854 36.6121 502.812 38.9337 499.058 38.9337C495.304 38.9337 492.262 36.6121 492.262 33.7484Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.262 33.7484C492.262 30.8846 495.304 28.563 499.058 28.563C502.812 28.563 505.854 30.8846 505.854 33.7484C505.854 36.6121 502.812 38.9337 499.058 38.9337C495.304 38.9337 492.262 36.6121 492.262 33.7484Z",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.669 33.7484C478.669 30.8846 481.712 28.563 485.466 28.563C489.219 28.563 492.262 30.8846 492.262 33.7484C492.262 36.6121 489.219 38.9337 485.466 38.9337C481.712 38.9337 478.669 36.6121 478.669 33.7484Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.669 33.7484C478.669 30.8846 481.712 28.563 485.466 28.563C489.219 28.563 492.262 30.8846 492.262 33.7484C492.262 36.6121 489.219 38.9337 485.466 38.9337C481.712 38.9337 478.669 36.6121 478.669 33.7484Z",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.076 33.7484C465.076 30.8846 468.119 28.563 471.873 28.563C475.626 28.563 478.669 30.8846 478.669 33.7484C478.669 36.6121 475.626 38.9337 471.873 38.9337C468.119 38.9337 465.076 36.6121 465.076 33.7484Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.076 33.7484C465.076 30.8846 468.119 28.563 471.873 28.563C475.626 28.563 478.669 30.8846 478.669 33.7484C478.669 36.6121 475.626 38.9337 471.873 38.9337C468.119 38.9337 465.076 36.6121 465.076 33.7484Z",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.059 26.9626C499.059 24.0989 502.101 21.7772 505.855 21.7772C509.608 21.7772 512.651 24.0989 512.651 26.9626C512.651 29.8263 509.608 32.1479 505.855 32.1479C502.101 32.1479 499.059 29.8263 499.059 26.9626Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.059 26.9626C499.059 24.0989 502.101 21.7772 505.855 21.7772C509.608 21.7772 512.651 24.0989 512.651 26.9626C512.651 29.8263 509.608 32.1479 505.855 32.1479C502.101 32.1479 499.059 29.8263 499.059 26.9626Z",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.465 26.9626C485.465 24.0989 488.508 21.7772 492.262 21.7772C496.015 21.7772 499.058 24.0989 499.058 26.9626C499.058 29.8263 496.015 32.1479 492.262 32.1479C488.508 32.1479 485.465 29.8263 485.465 26.9626Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.465 26.9626C485.465 24.0989 488.508 21.7772 492.262 21.7772C496.015 21.7772 499.058 24.0989 499.058 26.9626C499.058 29.8263 496.015 32.1479 492.262 32.1479C488.508 32.1479 485.465 29.8263 485.465 26.9626Z",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.873 26.9626C471.873 24.0989 474.916 21.7772 478.669 21.7772C482.423 21.7772 485.465 24.0989 485.465 26.9626C485.465 29.8263 482.423 32.1479 478.669 32.1479C474.916 32.1479 471.873 29.8263 471.873 26.9626Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.873 26.9626C471.873 24.0989 474.916 21.7772 478.669 21.7772C482.423 21.7772 485.465 24.0989 485.465 26.9626C485.465 29.8263 482.423 32.1479 478.669 32.1479C474.916 32.1479 471.873 29.8263 471.873 26.9626Z",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.262 20.3049C492.262 17.4412 495.304 15.1195 499.058 15.1195C502.812 15.1195 505.854 17.4412 505.854 20.3049C505.854 23.1686 502.812 25.4902 499.058 25.4902C495.304 25.4902 492.262 23.1686 492.262 20.3049Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.262 20.3049C492.262 17.4412 495.304 15.1195 499.058 15.1195C502.812 15.1195 505.854 17.4412 505.854 20.3049C505.854 23.1686 502.812 25.4902 499.058 25.4902C495.304 25.4902 492.262 23.1686 492.262 20.3049Z",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.669 20.3049C478.669 17.4412 481.712 15.1195 485.466 15.1195C489.219 15.1195 492.262 17.4412 492.262 20.3049C492.262 23.1686 489.219 25.4902 485.466 25.4902C481.712 25.4902 478.669 23.1686 478.669 20.3049Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.669 20.3049C478.669 17.4412 481.712 15.1195 485.466 15.1195C489.219 15.1195 492.262 17.4412 492.262 20.3049C492.262 23.1686 489.219 25.4902 485.466 25.4902C481.712 25.4902 478.669 23.1686 478.669 20.3049Z",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.076 33.7483C465.076 34.5088 464.861 35.2309 464.476 35.882C463.488 37.549 461.378 38.7474 458.881 38.9125C458.752 38.9222 458.621 38.928 458.491 38.9298L461.512 31.3785L462.247 29.5387C463.407 30.1742 464.292 31.0825 464.744 32.1408C464.959 32.6479 465.076 33.1874 465.076 33.7483Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.076 33.7483C465.076 34.5088 464.861 35.2309 464.476 35.882C463.488 37.549 461.378 38.7474 458.881 38.9125C458.752 38.9222 458.621 38.928 458.491 38.9298L461.512 31.3785L462.247 29.5387C463.407 30.1742 464.292 31.0825 464.744 32.1408C464.959 32.6479 465.076 33.1874 465.076 33.7483Z",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.873 26.9633C471.873 27.5242 471.756 28.0657 471.54 28.5708C470.686 30.57 468.283 32.0371 465.411 32.141H465.41C465.3 32.1466 465.188 32.1487 465.077 32.1487C464.965 32.1487 464.854 32.1466 464.744 32.141C463.561 32.0988 462.459 31.826 461.513 31.3784L462.248 29.5387L465.35 21.7836C465.352 21.7818 465.356 21.7818 465.358 21.7836C468.314 21.874 470.784 23.4045 471.592 25.4845C471.774 25.9532 471.873 26.4486 471.873 26.9633Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.873 26.9633C471.873 27.5242 471.756 28.0657 471.54 28.5708C470.686 30.57 468.283 32.0371 465.411 32.141H465.41C465.3 32.1466 465.188 32.1487 465.077 32.1487C464.965 32.1487 464.854 32.1466 464.744 32.141C463.561 32.0988 462.459 31.826 461.513 31.3784L462.248 29.5387L465.35 21.7836C465.352 21.7818 465.356 21.7818 465.358 21.7836C468.314 21.874 470.784 23.4045 471.592 25.4845C471.774 25.9532 471.873 26.4486 471.873 26.9633Z",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.372 14.9946C512.354 15.0386 512.337 15.083 512.318 15.1273C511.464 17.1265 509.059 18.5936 506.188 18.6973C506.078 18.7031 505.967 18.7052 505.855 18.7052C505.743 18.7052 505.632 18.7031 505.522 18.6973C502.649 18.5936 500.246 17.1265 499.392 15.1273C499.373 15.083 499.355 15.0386 499.338 14.9946H512.372Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.372 14.9946C512.354 15.0386 512.337 15.083 512.318 15.1273C511.464 17.1265 509.059 18.5936 506.188 18.6973C506.078 18.7031 505.967 18.7052 505.855 18.7052C505.743 18.7052 505.632 18.7031 505.522 18.6973C502.649 18.5936 500.246 17.1265 499.392 15.1273C499.373 15.083 499.355 15.0386 499.338 14.9946H512.372Z",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.78 14.9946C498.763 15.0386 498.746 15.083 498.726 15.1273C497.872 17.1265 495.468 18.5936 492.594 18.6973C492.484 18.7031 492.373 18.7052 492.262 18.7052C492.15 18.7052 492.038 18.7031 491.929 18.6973C489.057 18.5936 486.653 17.1265 485.799 15.1273C485.779 15.083 485.762 15.0386 485.745 14.9946H498.78Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.78 14.9946C498.763 15.0386 498.746 15.083 498.726 15.1273C497.872 17.1265 495.468 18.5936 492.594 18.6973C492.484 18.7031 492.373 18.7052 492.262 18.7052C492.15 18.7052 492.038 18.7031 491.929 18.6973C489.057 18.5936 486.653 17.1265 485.799 15.1273C485.779 15.083 485.762 15.0386 485.745 14.9946H498.78Z",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.354 21.774C465.356 21.7779 465.356 21.7799 465.358 21.7837C466.165 23.8616 468.635 25.3942 471.592 25.4844C471.684 25.4882 471.778 25.4902 471.873 25.4902C471.967 25.4902 472.061 25.4882 472.153 25.4844C475.111 25.3942 477.581 23.8616 478.389 21.7837C478.572 21.3151 478.67 20.8176 478.67 20.3049C478.67 19.744 478.553 19.2046 478.337 18.6974C477.483 16.6982 475.079 15.2308 472.205 15.1272C472.096 15.1213 471.984 15.1195 471.873 15.1195C470.226 15.1195 468.714 15.5671 467.539 16.3121",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.354 21.774C465.356 21.7779 465.356 21.7799 465.358 21.7837C466.165 23.8616 468.635 25.3942 471.592 25.4844C471.684 25.4882 471.778 25.4902 471.873 25.4902C471.967 25.4902 472.061 25.4882 472.153 25.4844C475.111 25.3942 477.581 23.8616 478.389 21.7837C478.572 21.3151 478.67 20.8176 478.67 20.3049C478.67 19.744 478.553 19.2046 478.337 18.6974C477.483 16.6982 475.079 15.2308 472.205 15.1272C472.096 15.1213 471.984 15.1195 471.873 15.1195C470.226 15.1195 468.714 15.5671 467.539 16.3121",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.187 14.9946C485.169 15.0386 485.152 15.083 485.133 15.1273C484.279 17.1265 481.874 18.5936 479.003 18.6973C478.893 18.7031 478.781 18.7052 478.67 18.7052C478.558 18.7052 478.447 18.7031 478.337 18.6973C475.463 18.5936 473.059 17.1265 472.207 15.1273H472.205C472.186 15.083 472.168 15.0386 472.151 14.9946H485.187Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.187 14.9946C485.169 15.0386 485.152 15.083 485.133 15.1273C484.279 17.1265 481.874 18.5936 479.003 18.6973C478.893 18.7031 478.781 18.7052 478.67 18.7052C478.558 18.7052 478.447 18.7031 478.337 18.6973C475.463 18.5936 473.059 17.1265 472.207 15.1273H472.205C472.186 15.083 472.168 15.0386 472.151 14.9946H485.187Z",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.307 14.9946C472.29 15.0386 472.272 15.083 472.253 15.1273L472.251 15.1291C472.245 15.1444 472.238 15.1617 472.23 15.1773C471.407 17.0399 469.234 18.4304 466.596 18.6667L467.539 16.3122L468.066 14.9946H472.307Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.307 14.9946C472.29 15.0386 472.272 15.083 472.253 15.1273L472.251 15.1291C472.245 15.1444 472.238 15.1617 472.23 15.1773C471.407 17.0399 469.234 18.4304 466.596 18.6667L467.539 16.3122L468.066 14.9946H472.307Z",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.471 65.627H447.811L447.996 65.1642L450.479 58.9589L450.748 58.2868L453.466 51.4919L454.416 49.1162L456.965 42.7442L458.491 38.9299L461.512 31.3786L462.247 29.5386L465.35 21.7837L465.353 21.774L466.596 18.6666L467.538 16.3121L468.065 14.9947H591.217L591.446 15.5671L592.121 17.255L595.02 24.4992L595.383 25.4115L596.801 28.9548L597.842 31.5533L599.607 35.9705L599.867 36.6195V36.6215L602.912 44.2304L603.56 45.8514L605.107 49.7156V49.7173L606.382 52.9035L607.405 55.4597L607.434 55.5308V55.5326L611.26 65.0987L611.471 65.627Z",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.4378 35.3345H93.7615C93.4861 31.3226 90.0726 28.1496 85.8907 28.1496C84.9478 28.1496 84.0471 28.3191 83.2085 28.6151C83.2158 28.4594 83.2328 28.3067 83.2328 28.1496C83.2328 22.5203 78.5559 17.9572 72.7868 17.9572C71.2373 17.9572 69.7716 18.2952 68.4491 18.886C65.8744 16.4443 62.3662 14.9349 58.4922 14.9349C52.7283 14.9349 47.774 18.2705 45.5128 23.065C45.0807 23.0145 44.6437 22.9813 44.1976 22.9813C38.125 22.9813 33.202 27.7846 33.202 33.7097C33.202 34.3554 33.2706 34.9841 33.3828 35.5982C30.7442 36.379 28.8037 38.8237 28.8037 41.7027C28.8037 45.2048 31.6739 48.0706 35.1815 48.0706H95.4378C98.9457 48.0706 101.816 45.2048 101.816 41.7027C101.816 38.2002 98.9457 35.3345 95.4378 35.3345Z",
    fill: "#E5E6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.4378 35.3345H93.7615C93.4861 31.3226 90.0726 28.1496 85.8907 28.1496C84.9478 28.1496 84.0471 28.3191 83.2085 28.6151C83.2158 28.4594 83.2328 28.3067 83.2328 28.1496C83.2328 22.5203 78.5559 17.9572 72.7868 17.9572C71.2373 17.9572 69.7716 18.2952 68.4491 18.886C65.8744 16.4443 62.3662 14.9349 58.4922 14.9349C52.7283 14.9349 47.774 18.2705 45.5128 23.065C45.0807 23.0145 44.6437 22.9813 44.1976 22.9813C38.125 22.9813 33.202 27.7846 33.202 33.7097C33.202 34.3554 33.2706 34.9841 33.3828 35.5982C30.7442 36.379 28.8037 38.8237 28.8037 41.7027C28.8037 45.2048 31.6739 48.0706 35.1815 48.0706H95.4378C98.9457 48.0706 101.816 45.2048 101.816 41.7027C101.816 38.2002 98.9457 35.3345 95.4378 35.3345Z",
    stroke: "#040606",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.57886 62.1323H70.7461V28.2795H191.962V76.3878H345.78V86.2827H354.951V218.84H8.57886V63.4261V62.1323Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.57886 62.1323H70.7461V28.2795H191.962V76.3878H345.78V86.2827H354.951V218.84H8.57886V63.4261V62.1323Z",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.243 218.757H332.328V54.4736H466.243V218.757Z",
    fill: "white",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.871 1.56617H347.701L332.328 54.4736H466.244L450.871 1.56617Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.871 1.56617H347.701L332.328 54.4736H466.244L450.871 1.56617Z",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.019 55.2951L438.419 19.1527L410.819 55.2951V218.757H466.019V55.2951Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.019 55.2951L438.419 19.1527L410.819 55.2951V218.757H466.019V55.2951Z",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.149994,
    d: "M434.492 83.9816H420.78V70.2911H434.492V83.9816Z",
    fill: "#231F20",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.149994,
    d: "M456.059 83.9816H442.347V70.2911H456.059V83.9816Z",
    fill: "#231F20",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.149994,
    d: "M434.492 103.422H420.78V89.7314H434.492V103.422Z",
    fill: "#231F20",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.149994,
    d: "M456.059 103.422H442.347V89.7314H456.059V103.422Z",
    fill: "#231F20",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.149994,
    d: "M434.492 122.862H420.78V109.172H434.492V122.862Z",
    fill: "#231F20",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.149994,
    d: "M456.059 122.862H442.347V109.172H456.059V122.862Z",
    fill: "#231F20",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.149994,
    d: "M434.492 142.302H420.78V128.612H434.492V142.302Z",
    fill: "#231F20",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.149994,
    d: "M456.059 142.302H442.347V128.612H456.059V142.302Z",
    fill: "#231F20",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.149994,
    d: "M434.492 161.742H420.78V148.052H434.492V161.742Z",
    fill: "#231F20",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.149994,
    d: "M456.059 161.742H442.347V148.052H456.059V161.742Z",
    fill: "#231F20",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.149994,
    d: "M449.202 174.064H427.636V218.757H449.202V174.064Z",
    fill: "#231F20",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.819 99.8621H332.328V97.3977H410.819V99.8621Z",
    fill: "white",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.819 133.13H332.328V130.665H410.819V133.13Z",
    fill: "white",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.819 166.397H332.328V163.932H410.819V166.397Z",
    fill: "white",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.819 199.664H332.328V197.2H410.819V199.664Z",
    fill: "white",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.149994,
    d: "M359.165 48.0764H347.472V36.4025H359.165V48.0764Z",
    fill: "#231F20",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.149994,
    d: "M376.96 48.0764H365.268V36.4025H376.96V48.0764Z",
    fill: "#231F20",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.149994,
    d: "M394.756 48.0764H383.064V36.4025H394.756V48.0764Z",
    fill: "#231F20",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.149994,
    d: "M294.901 56.5619C294.901 78.5071 277.084 96.2972 255.105 96.2972C233.125 96.2972 215.308 78.5071 215.308 56.5619C215.308 34.6168 233.125 16.827 255.105 16.827C277.084 16.827 294.901 34.6168 294.901 56.5619Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.149994,
    d: "M329.023 93.2659C329.023 109.93 315.494 123.438 298.804 123.438C282.114 123.438 268.585 109.93 268.585 93.2659C268.585 76.6022 282.114 63.0935 298.804 63.0935C315.494 63.0935 329.023 76.6022 329.023 93.2659Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.149994,
    d: "M249.356 116.808C249.356 128.44 239.911 137.87 228.261 137.87C216.61 137.87 207.166 128.44 207.166 116.808C207.166 105.176 216.61 95.7454 228.261 95.7454C239.911 95.7454 249.356 105.176 249.356 116.808Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.058 83.3205L256.536 140.492",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.536 151.21L228.26 114.907",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.535 35.6079V218.757",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.562 131.706L221.624 137.362L219.911 126.26H210.562V131.706Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.562 131.706L221.624 137.362L219.911 126.26H210.562V131.706Z",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.256 171.784L206.866 171.939H203.933L216.13 199.379L222.615 214.178H224.313L227.401 214.024H229.254L227.247 171.476H226.475",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.256 171.784L206.866 171.939H203.933L216.13 199.379L222.615 214.178H224.313L227.401 214.024H229.254L227.247 171.476H226.475",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.001 214.183L222.792 218.388H234.894C236.515 218.388 235.344 217.12 233.606 216.29C230.368 214.745 228.095 214.256 228.095 214.256L223.001 214.183Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.001 214.183L222.792 218.388H234.894C236.515 218.388 235.344 217.12 233.606 216.29C230.368 214.745 228.095 214.256 228.095 214.256L223.001 214.183Z",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.456 214.955L200.162 218.839H212.776C214.464 218.839 213.246 217.787 211.434 216.922C208.061 215.313 205.442 214.938 205.442 214.938L200.456 214.955Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.456 214.955L200.162 218.839H212.776C214.464 218.839 213.246 217.787 211.434 216.922C208.061 215.313 205.442 214.938 205.442 214.938L200.456 214.955Z",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.712 171.476H203.16L200.456 214.955H202.244L205.443 214.938L206.786 215.224L214.486 202.168C215.58 200.312 216.507 198.363 217.256 196.343L226.475 171.476L226.629 171.168V171.014L215.358 171.168L213.814 171.322",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.712 171.476H203.16L200.456 214.955H202.244L205.443 214.938L206.786 215.224L214.486 202.168C215.58 200.312 216.507 198.363 217.256 196.343L226.475 171.476L226.629 171.168V171.014L215.358 171.168L213.814 171.322",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.563 130.72C210.428 130.746 210.296 130.773 210.167 130.799C202.754 132.388 203.466 135.9 198.369 141.609L210.176 177.308L210.179 177.437L210.202 179.511V180.876C210.202 182.573 211.617 183.951 213.319 183.951C215.018 183.951 216.436 182.573 216.436 180.876V178.415C216.86 178.415 217.135 177.966 216.945 177.587L215.718 175.15L201.881 147.664C201.881 139.206 206.354 139.641 214.825 139.641L214.936 139.236C223.407 139.236 227.883 139.53 227.883 147.987L228.726 162.578L230.369 176.101L230.601 178.013C230.68 178.667 231.233 179.158 231.89 179.158H232.376V181.619C232.376 183.316 233.793 184.691 235.492 184.691C237.194 184.691 238.609 183.316 238.609 181.619V180.251L238.163 177.035L238.044 176.101L234.57 149.167C234.564 149.097 234.555 149.026 234.549 148.959C234.479 148.239 234.391 147.537 234.286 146.859C234.282 146.85 234.282 146.842 234.282 146.833C233.152 139.43 230.097 134.396 224.567 131.924C223.175 131.298 221.626 130.837 219.912 130.541",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.563 130.72C210.428 130.746 210.296 130.773 210.167 130.799C202.754 132.388 203.466 135.9 198.369 141.609L210.176 177.308L210.179 177.437L210.202 179.511V180.876C210.202 182.573 211.617 183.951 213.319 183.951C215.018 183.951 216.436 182.573 216.436 180.876V178.415C216.86 178.415 217.135 177.966 216.945 177.587L215.718 175.15L201.881 147.664C201.881 139.206 206.354 139.641 214.825 139.641L214.936 139.236C223.407 139.236 227.883 139.53 227.883 147.987L228.726 162.578L230.369 176.101L230.601 178.013C230.68 178.667 231.233 179.158 231.89 179.158H232.376V181.619C232.376 183.316 233.793 184.691 235.492 184.691C237.194 184.691 238.609 183.316 238.609 181.619V180.251L238.163 177.035L238.044 176.101L234.57 149.167C234.564 149.097 234.555 149.026 234.549 148.959C234.479 148.239 234.391 147.537 234.286 146.859C234.282 146.85 234.282 146.842 234.282 146.833C233.152 139.43 230.097 134.396 224.567 131.924C223.175 131.298 221.626 130.837 219.912 130.541",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.359 171.322L227.202 171.16L226.707 150.608C226.706 150.577 226.751 150.574 226.755 150.604L230.181 176.101H230.489H238.055H238.21C238.21 176.101 236.357 161.61 234.967 152.206C234.813 150.356 234.504 148.815 234.35 147.581C234.195 145.577 233.886 144.19 233.886 143.882C233.114 140.182 231.571 137.099 229.1 134.94C227.556 133.244 225.549 132.166 223.078 131.395C222.152 131.086 221.071 130.778 219.99 130.624C221.612 131.029 222.085 131.719 222.104 132.393C222.133 133.437 221.073 134.171 220.078 133.863L216.648 133.064C216.606 133.054 216.563 133.042 216.521 133.029L215.237 132.609L210.109 130.778L209.491 130.624C202.852 131.703 198.375 135.865 196.522 141.569C195.287 145.577 197.294 152.206 200.227 158.835C201.463 161.61 202.852 164.385 204.242 167.006C205.168 168.547 205.94 170.089 206.712 171.476C206.867 171.63 206.867 171.785 206.867 171.939C208.256 174.251 209.337 175.947 209.954 177.026C210.109 177.18 210.109 177.334 210.109 177.334C210.418 177.797 210.572 177.951 210.572 177.951L215.667 175.176L216.594 174.714L215.513 171.63L215.359 171.322V171.168L208.922 152.618C208.687 151.941 208.606 151.22 208.686 150.507L209.028 147.427",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.359 171.322L227.202 171.16L226.707 150.608C226.706 150.577 226.751 150.574 226.755 150.604L230.181 176.101H230.489H238.055H238.21C238.21 176.101 236.357 161.61 234.967 152.206C234.813 150.356 234.504 148.815 234.35 147.581C234.195 145.577 233.886 144.19 233.886 143.882C233.114 140.182 231.571 137.099 229.1 134.94C227.556 133.244 225.549 132.166 223.078 131.395C222.152 131.086 221.071 130.778 219.99 130.624C221.612 131.029 222.085 131.719 222.104 132.393C222.133 133.437 221.073 134.171 220.078 133.863L216.648 133.064C216.606 133.054 216.563 133.042 216.521 133.029L215.237 132.609L210.109 130.778L209.491 130.624C202.852 131.703 198.375 135.865 196.522 141.569C195.287 145.577 197.294 152.206 200.227 158.835C201.463 161.61 202.852 164.385 204.242 167.006C205.168 168.547 205.94 170.089 206.712 171.476C206.867 171.63 206.867 171.785 206.867 171.939C208.256 174.251 209.337 175.947 209.954 177.026C210.109 177.18 210.109 177.334 210.109 177.334C210.418 177.797 210.572 177.951 210.572 177.951L215.667 175.176L216.594 174.714L215.513 171.63L215.359 171.322ZM215.359 171.322V171.168L208.922 152.618C208.687 151.941 208.606 151.22 208.686 150.507L209.028 147.427",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.161 171.476H206.107H206.491H206.107",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.71 150.745L226.335 143.301",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.362 171.476L200.185 158.898",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.814 109.169C195.814 119.906 205.642 128.609 214.777 128.609C223.913 128.609 233.739 119.906 233.739 109.169C233.739 98.4302 225.25 89.7257 214.777 89.7257C204.305 89.7257 195.814 98.4302 195.814 109.169Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.814 109.169C195.814 119.906 205.642 128.609 214.777 128.609C223.913 128.609 233.739 119.906 233.739 109.169C233.739 98.4302 225.25 89.7257 214.777 89.7257C204.305 89.7257 195.814 98.4302 195.814 109.169Z",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.174 99.1831C227.174 99.1831 220.515 122.704 214.621 124.454L214.182 122.191C214.182 122.191 211.455 125.816 207.948 126.205L206.78 124.26L202.884 129.511C202.884 129.511 192.571 111.435 196.856 101.517C201.142 91.5986 214.971 84.4029 226.073 91.9877L228.216 90.4316L227.174 99.1831Z",
    fill: "white",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.037 218.839H318.525V14.9944H324.037V218.839Z",
    fill: "white",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.815 218.839H311.746V207.415H330.815V218.839Z",
    fill: "white",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.686 34.4124H321.585V14.9944H368.686L376.041 24.7035L368.686 34.4124Z",
    fill: "#F14E1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.686 34.4124H321.585V14.9944H368.686L376.041 24.7035L368.686 34.4124Z",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.18 65.0143H321.281V45.5964H274.18L266.825 55.3052L274.18 65.0143Z",
    fill: "#F14E1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.18 65.0143H321.281V45.5964H274.18L266.825 55.3052L274.18 65.0143Z",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.18 99.2882H321.281V79.8706H274.18L266.825 89.5794L274.18 99.2882Z",
    fill: "#F14E1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.18 99.2882H321.281V79.8706H274.18L266.825 89.5794L274.18 99.2882Z",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.774 79.6519H118.374V36.4661H153.774V79.6519Z",
    fill: "white",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.868 77.3655H120.574V38.7525H133.868V77.3655Z",
    fill: "white",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.652 77.3655H138.358V38.7525H151.652V77.3655Z",
    fill: "white",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.073 36.466V79.6517V36.466Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.073 36.466V79.6517",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.053 63.0163H86.0629H85.5239V83.373H86.0629H131.053H186.624V63.0163H131.053Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.053 63.0163H86.0629H85.5239V83.373H86.0629H131.053H186.624V63.0163H131.053Z",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.149994,
    d: "M110.643 57.4248C110.504 57.4248 110.374 57.4574 110.238 57.4657C110.238 57.4598 110.24 57.4545 110.24 57.4486C110.24 54.8207 108.106 52.6905 105.474 52.6905C104.183 52.6905 103.016 53.208 102.157 54.0408C100.781 52.4207 98.7528 51.3709 96.4588 51.3709C92.315 51.3709 88.9556 54.7247 88.9556 58.8623C88.9556 59.5077 89.0628 60.1232 89.2169 60.7211C87.8305 61.218 86.8337 62.5288 86.8337 64.0837H117.469C117.374 60.3925 114.363 57.4248 110.643 57.4248Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.149994,
    d: "M183.326 63.9941C184.553 62.6671 185.313 60.904 185.313 58.9518C185.313 54.8142 181.954 51.4601 177.81 51.4601C174.394 51.4601 171.544 53.7535 170.637 56.8718C170.526 56.8624 170.42 56.8387 170.307 56.8387C169.891 56.8387 169.497 56.9209 169.121 57.041C168.103 54.544 165.656 52.7801 162.789 52.7801C159.041 52.7801 156.005 55.7918 155.956 59.5227C155.622 59.4378 155.279 59.3788 154.92 59.3788C152.602 59.3788 150.723 61.2546 150.723 63.5686C150.723 63.7146 150.751 63.8523 150.766 63.9941H183.326Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.13 63.0163H84.985H84.446V67.2302H84.985H132.13H187.701V63.0163H132.13Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.13 63.0163H84.985H84.446V67.2302H84.985H132.13H187.701V63.0163H132.13Z",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-17.1978 135.082V149.366H-10.1957V218.901H10.8138V163.12H39.5738V218.901H62.4588V149.366H71.2122V135.082H-17.1978Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-17.1978 135.082V149.366H-10.1957V218.901H10.8138V163.12H39.5738V218.901H62.4588V149.366H71.2122V135.082H-17.1978Z",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.572 131.259H147.177V110.253H163.572V131.259ZM136.793 131.259H120.398V110.253H136.793V131.259ZM110.013 131.259H93.6184V110.253H110.013V131.259ZM83.2371 131.259H66.842V110.253H83.2371V131.259ZM44.5713 80.3096V103.979H56.1849V218.904H90.8874V161.065H138.433V218.904H176.277V103.979H190.759V80.3096H44.5713Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.572 131.259H147.177V110.253H163.572V131.259ZM136.793 131.259H120.398V110.253H136.793V131.259ZM110.013 131.259H93.6184V110.253H110.013V131.259ZM83.2371 131.259H66.842V110.253H83.2371V131.259ZM44.5713 80.3096V103.979H56.1849V218.904H90.8874V161.065H138.433V218.904H176.277V103.979H190.759V80.3096H44.5713Z",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.149994,
    d: "M66.3226 128.212C66.3226 158.517 53.5377 183.084 37.7665 183.084C21.9954 183.084 9.21045 158.517 9.21045 128.212C9.21045 97.9073 21.9954 73.3404 37.7665 73.3404C53.5377 73.3404 66.3226 97.9073 66.3226 128.212Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1436 94.6372V218.52",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4826 136.371L36.1433 160.673",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6582 121.263L36.1435 139.72",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1924 108.607L36.1433 120.637",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_16043"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 505,
    height: 219,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoices);
export default __webpack_public_path__ + "static/media/invoices.50215230.svg";
export { ForwardRef as ReactComponent };